import GenerateLinkModal from "./GenerateLinkModal";

export default GenerateLinkModal;
